(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rastrear_melon"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-rm-form]').forEach(function (form) {
    if (form.dataset.rmBound === 'true') {
      return;
    }
    form.dataset.rmBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var input = form.querySelector('.rm-tracker__input');
      var code = (input.value || '').trim();

      if (code === '') {
        input.focus();
        return;
      }

      var base = (form.dataset.baseUrl || '').trim();
      if (base === '') {
        return;
      }

      var mode = (form.dataset.mode || 'path').trim();
      var prefix = (form.dataset.prefix || '').trim();
      var fullCode = code;

      if (prefix !== '' && code.indexOf(prefix) !== 0) {
        fullCode = prefix + code;
      }

      var url;

      if (mode === 'query') {
        var param = (form.dataset.param || '').trim();
        url = base;
        if (param !== '') {
          var separator = base.indexOf('?') === -1 ? '?' : '&';
          url = base + separator + encodeURIComponent(param) + '=' + encodeURIComponent(fullCode);
        }
      } else {
        var trimmedBase = base.replace(/\/+$/, '');
        url = trimmedBase + '/' + encodeURIComponent(fullCode);
      }

      if (form.dataset.newTab === 'true') {
        window.open(url, '_blank', 'noopener');
      } else {
        window.location.href = url;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
